/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { OppulenceBackendSDKCore } from "../core.js";
import { SDKOptions } from "../lib/config.js";
import type { ConsoleLogger } from "./console-logger.js";
import { MCPScope, mcpScopes } from "./scopes.js";
import { createRegisterTool } from "./tools.js";
import { tool$accountsCreate } from "./tools/accountsCreate.js";
import { tool$accountsDelete } from "./tools/accountsDelete.js";
import { tool$accountsFetchById } from "./tools/accountsFetchById.js";
import { tool$accountsGet } from "./tools/accountsGet.js";
import { tool$accountsGetUsage } from "./tools/accountsGetUsage.js";
import { tool$accountsList } from "./tools/accountsList.js";
import { tool$accountsModifyDetails } from "./tools/accountsModifyDetails.js";
import { tool$accountsRegister } from "./tools/accountsRegister.js";
import { tool$accountsRemoveById } from "./tools/accountsRemoveById.js";
import { tool$accountsUpdate } from "./tools/accountsUpdate.js";
import { tool$accountsUpdateSettings } from "./tools/accountsUpdateSettings.js";
import { tool$apiKeysCreate } from "./tools/apiKeysCreate.js";
import { tool$apiKeysDelete } from "./tools/apiKeysDelete.js";
import { tool$apiKeysGet } from "./tools/apiKeysGet.js";
import { tool$apiKeysGetTenantDetails } from "./tools/apiKeysGetTenantDetails.js";
import { tool$apiKeysList } from "./tools/apiKeysList.js";
import { tool$apiKeysRotate } from "./tools/apiKeysRotate.js";
import { tool$apiKeysUpdate } from "./tools/apiKeysUpdate.js";
import { tool$jobsCreate } from "./tools/jobsCreate.js";
import { tool$jobsDelete } from "./tools/jobsDelete.js";
import { tool$jobsDownload } from "./tools/jobsDownload.js";
import { tool$jobsGet } from "./tools/jobsGet.js";
import { tool$jobsGetAll } from "./tools/jobsGetAll.js";
import { tool$leadsGet } from "./tools/leadsGet.js";
import { tool$leadsList } from "./tools/leadsList.js";
import { tool$organizationsCreate } from "./tools/organizationsCreate.js";
import { tool$organizationsDelete } from "./tools/organizationsDelete.js";
import { tool$organizationsGet } from "./tools/organizationsGet.js";
import { tool$organizationsList } from "./tools/organizationsList.js";
import { tool$organizationsUpdate } from "./tools/organizationsUpdate.js";
import { tool$tenantApiKeysCreate } from "./tools/tenantApiKeysCreate.js";
import { tool$tenantApiKeysUpdate } from "./tools/tenantApiKeysUpdate.js";
import { tool$tenantsCreate } from "./tools/tenantsCreate.js";
import { tool$tenantsDelete } from "./tools/tenantsDelete.js";
import { tool$tenantsDeleteApiKey } from "./tools/tenantsDeleteApiKey.js";
import { tool$tenantsGet } from "./tools/tenantsGet.js";
import { tool$tenantsList } from "./tools/tenantsList.js";
import { tool$tenantsListApiKeys } from "./tools/tenantsListApiKeys.js";
import { tool$tenantsRotateApiKey } from "./tools/tenantsRotateApiKey.js";
import { tool$tenantsUpdate } from "./tools/tenantsUpdate.js";
import { tool$webhooksCreate } from "./tools/webhooksCreate.js";
import { tool$webhooksDelete } from "./tools/webhooksDelete.js";
import { tool$webhooksGet } from "./tools/webhooksGet.js";
import { tool$webhooksList } from "./tools/webhooksList.js";
import { tool$webhooksUpdate } from "./tools/webhooksUpdate.js";
import { tool$workflowsDelete } from "./tools/workflowsDelete.js";
import { tool$workflowsGet } from "./tools/workflowsGet.js";
import { tool$workflowsPause } from "./tools/workflowsPause.js";
import { tool$workflowsTrigger } from "./tools/workflowsTrigger.js";
import { tool$workflowsUpdate } from "./tools/workflowsUpdate.js";
import { tool$workspacesCreate } from "./tools/workspacesCreate.js";
import { tool$workspacesCreateWorkflow } from "./tools/workspacesCreateWorkflow.js";
import { tool$workspacesDelete } from "./tools/workspacesDelete.js";
import { tool$workspacesFetchAnalytics } from "./tools/workspacesFetchAnalytics.js";
import { tool$workspacesFetchById } from "./tools/workspacesFetchById.js";
import { tool$workspacesGenerate } from "./tools/workspacesGenerate.js";
import { tool$workspacesGet } from "./tools/workspacesGet.js";
import { tool$workspacesGetAnalytics } from "./tools/workspacesGetAnalytics.js";
import { tool$workspacesGetComplianceReport } from "./tools/workspacesGetComplianceReport.js";
import { tool$workspacesGetStorageStats } from "./tools/workspacesGetStorageStats.js";
import { tool$workspaceSharingsDelete } from "./tools/workspaceSharingsDelete.js";
import { tool$workspaceSharingsUpdate } from "./tools/workspaceSharingsUpdate.js";
import { tool$workspacesList } from "./tools/workspacesList.js";
import { tool$workspacesListSharings } from "./tools/workspacesListSharings.js";
import { tool$workspacesListWorkflows } from "./tools/workspacesListWorkflows.js";
import { tool$workspacesModify } from "./tools/workspacesModify.js";
import { tool$workspacesRemoveById } from "./tools/workspacesRemoveById.js";
import { tool$workspacesRetrieveList } from "./tools/workspacesRetrieveList.js";
import { tool$workspacesShare } from "./tools/workspacesShare.js";
import { tool$workspacesUpdate } from "./tools/workspacesUpdate.js";

export function createMCPServer(deps: {
  logger: ConsoleLogger;
  scopes?: MCPScope[] | undefined;
  serverURL?: string | undefined;
  serverIdx?: SDKOptions["serverIdx"] | undefined;
}) {
  const server = new McpServer({
    name: "OppulenceBackendSDK",
    version: "0.5.1",
  });

  const client = new OppulenceBackendSDKCore({
    serverURL: deps.serverURL,
    serverIdx: deps.serverIdx,
  });
  const scopes = new Set(deps.scopes ?? mcpScopes);
  const tool = createRegisterTool(deps.logger, server, client, scopes);

  tool(tool$accountsRegister);
  tool(tool$accountsList);
  tool(tool$accountsUpdateSettings);
  tool(tool$accountsModifyDetails);
  tool(tool$accountsFetchById);
  tool(tool$accountsRemoveById);
  tool(tool$accountsGetUsage);
  tool(tool$accountsCreate);
  tool(tool$accountsUpdate);
  tool(tool$accountsGet);
  tool(tool$accountsDelete);
  tool(tool$apiKeysCreate);
  tool(tool$apiKeysUpdate);
  tool(tool$apiKeysList);
  tool(tool$apiKeysRotate);
  tool(tool$apiKeysGet);
  tool(tool$apiKeysDelete);
  tool(tool$apiKeysGetTenantDetails);
  tool(tool$jobsGetAll);
  tool(tool$jobsCreate);
  tool(tool$jobsGet);
  tool(tool$jobsDelete);
  tool(tool$jobsDownload);
  tool(tool$leadsList);
  tool(tool$leadsGet);
  tool(tool$organizationsList);
  tool(tool$organizationsCreate);
  tool(tool$organizationsUpdate);
  tool(tool$organizationsGet);
  tool(tool$organizationsDelete);
  tool(tool$tenantsList);
  tool(tool$tenantsDelete);
  tool(tool$tenantsUpdate);
  tool(tool$tenantsListApiKeys);
  tool(tool$tenantsRotateApiKey);
  tool(tool$tenantsDeleteApiKey);
  tool(tool$tenantsGet);
  tool(tool$tenantsCreate);
  tool(tool$tenantApiKeysCreate);
  tool(tool$tenantApiKeysUpdate);
  tool(tool$webhooksList);
  tool(tool$webhooksCreate);
  tool(tool$webhooksUpdate);
  tool(tool$webhooksGet);
  tool(tool$webhooksDelete);
  tool(tool$workspacesUpdate);
  tool(tool$workspacesFetchById);
  tool(tool$workspacesRemoveById);
  tool(tool$workspacesList);
  tool(tool$workspacesCreate);
  tool(tool$workspacesFetchAnalytics);
  tool(tool$workspacesListWorkflows);
  tool(tool$workspacesCreateWorkflow);
  tool(tool$workspacesGenerate);
  tool(tool$workspacesModify);
  tool(tool$workspacesGetAnalytics);
  tool(tool$workspacesGetComplianceReport);
  tool(tool$workspacesRetrieveList);
  tool(tool$workspacesListSharings);
  tool(tool$workspacesGetStorageStats);
  tool(tool$workspacesGet);
  tool(tool$workspacesDelete);
  tool(tool$workspacesShare);
  tool(tool$workflowsUpdate);
  tool(tool$workflowsGet);
  tool(tool$workflowsDelete);
  tool(tool$workflowsPause);
  tool(tool$workflowsTrigger);
  tool(tool$workspaceSharingsUpdate);
  tool(tool$workspaceSharingsDelete);

  return server;
}
